import { render, staticRenderFns } from "./NotificationHistorySearchForm.vue?vue&type=template&id=39637726&"
import script from "./NotificationHistorySearchForm.vue?vue&type=script&lang=ts&"
export * from "./NotificationHistorySearchForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports